// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1065":"676c47e2","1935":"676c47e2","2748":"676c47e2","2757":"676c47e2","8078":"676c47e2"}[chunkId] + ".chunk.css";
};